import {
  Stack,
  Typography
} from '@mui/material';
import { SiteUser_RegisterInput } from 'generated/graphql';
import { authUtil } from 'modules/common';
import { StyledTextField } from 'modules/components/layer01';
import { FormBaseLayout } from 'modules/components/layer10';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import * as ds from './dataService';
import * as types from './types';



export type RegisterFormProps = {};



/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: RegisterFormProps) => {
  const params = useParams();
  const form = ds.useFormState();


  const [
    fnRegisterUser
    // {
    //   loading,
    //   error
    // }
  ] = ds.useRegisterUser();

  const handleSubmit = useCallback(async (input: SiteUser_RegisterInput, password: string, preferredEmail: string, authState: types.IAuthState, confirmationCode: string) => {

    const updateAuthStatus = (status: types.IAuthState) => {
      form.dispatch({
        type: 'UPDATE',
        payload: {
          property: 'authState',
          value: status
        }
      });

      form.dispatch({
        type: 'UPDATE',
        payload: {
          property: 'errorMessage',
          value: ''
        }
      });
    };

    switch (authState) {
      case 'NOT_STARTED':
        const signUp = await authUtil.signUp(preferredEmail, password);
        updateAuthStatus(signUp);
        break;

      case 'CONFIRM_SIGN_UP':
        try {
          // isConfirmed
          await authUtil.confirmSignUp({
            email: preferredEmail,
            password: password,
            confirmationCode: confirmationCode.trim()
          });
          authUtil.holdEvents();
          await authUtil.signIn(preferredEmail, password);
          await fnRegisterUser(input);

        } finally {
          authUtil.releaseEvents();
        }

        break;
      default:
        break;
    }

  }, [
    fnRegisterUser,
    form
  ]);


  return (
    <FormBaseLayout.FC
      handleCancel={() => {
        form.dispatch({
          type: 'UPDATE',
          payload: {
            property: 'activeStep',
            value: form.formState.activeStep - 1
          }
        });
      }}
      handleSubmit={async () => {
        const input: SiteUser_RegisterInput = {
          preferredEmail: form.formState.preferredEmail,
          firstName: form.formState.firstName,
          inviteCode: params.inviteCode ?? '',
          lastName: form.formState.lastName,
          phoneNumber: form.formState.phone
        };
        await handleSubmit(input, form.formState.password, form.formState.preferredEmail, form.formState.authState, form.formState.confirmationCode);

      }}
      cancelButtonText='Previous'
      ignoreCancel={true}
      successButtonText='Continue'
      title={__step2Title[form.formState.authState]}
    >
      <Stack
        rowGap='2rem'
        paddingTop='2rem'
        paddingBottom='2rem'
      >
        {__step2Instructions[form.formState.authState].map((instr, i) => (
          <Typography key={i}>
            {instr}
          </Typography>
        ))}

        {__authStep2Fields[form.formState.authState].map((node, i) => (
          <StyledTextField.FC
            key={i}
            {...form.genFieldProps(node)}
          />
        ))}
      </Stack>
    </FormBaseLayout.FC>

  );
};



const __authStep2Fields: Record<types.IAuthState, (keyof types.IRegisterUserFormState)[]> = {
  NOT_STARTED: [
    'firstName',
    'lastName',
    'preferredEmail',
    'phone',
    'password',
    'confirmPassword'
  ],
  CONFIRM_SIGN_IN_WITH_PASSWORD: [],
  CONTINUE_SIGN_IN_WITH_EMAIL_SETUP: [],
  CONTINUE_SIGN_IN_WITH_FIRST_FACTOR_SELECTION: [],
  CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION: [],
  CREATE_PASSWORD: [],
  SELECT_MFA_METHOD: [],
  CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE: [],
  CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED: [],
  CONFIRM_SIGN_IN_WITH_SMS_CODE: [],
  CONFIRM_SIGN_IN_WITH_EMAIL_CODE: [],
  CONFIRM_SIGN_IN_WITH_TOTP_CODE: [],
  CONFIRM_SIGN_UP: ['confirmationCode'],
  CONTINUE_SIGN_IN_WITH_MFA_SELECTION: [],
  CONTINUE_SIGN_IN_WITH_TOTP_SETUP: [],
  DONE: [],
  RESET_PASSWORD: [],
  COMPLETE_AUTO_SIGN_IN: []
};

const __step2Title: Record<types.IAuthState, string> = {
  NOT_STARTED: 'Profile Information',
  SELECT_MFA_METHOD: '',
  CREATE_PASSWORD: '',
  CONFIRM_SIGN_IN_WITH_PASSWORD: '',
  CONTINUE_SIGN_IN_WITH_EMAIL_SETUP: '',
  CONTINUE_SIGN_IN_WITH_FIRST_FACTOR_SELECTION: '',
  CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION: '',
  CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE: '',
  CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED: '',
  CONFIRM_SIGN_IN_WITH_SMS_CODE: '',
  CONFIRM_SIGN_IN_WITH_EMAIL_CODE: '',
  CONFIRM_SIGN_IN_WITH_TOTP_CODE: '',
  CONFIRM_SIGN_UP: 'Confirm your email',
  CONTINUE_SIGN_IN_WITH_MFA_SELECTION: '',
  CONTINUE_SIGN_IN_WITH_TOTP_SETUP: '',
  DONE: '',
  RESET_PASSWORD: '',
  COMPLETE_AUTO_SIGN_IN: ''
};

const __step2Instructions: Record<types.IAuthState, string[]> = {
  NOT_STARTED: [],
  SELECT_MFA_METHOD: [],
  CREATE_PASSWORD: [],
  CONFIRM_SIGN_IN_WITH_PASSWORD: [],
  CONTINUE_SIGN_IN_WITH_EMAIL_SETUP: [],
  CONTINUE_SIGN_IN_WITH_FIRST_FACTOR_SELECTION: [],
  CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION: [],
  CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE: [],
  CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED: [],
  CONFIRM_SIGN_IN_WITH_SMS_CODE: [],
  CONFIRM_SIGN_IN_WITH_EMAIL_CODE: [],
  CONFIRM_SIGN_IN_WITH_TOTP_CODE: [],
  CONFIRM_SIGN_UP: [
    'Do not close this window.',
    'Please check your email for the verification code.'
  ],
  CONTINUE_SIGN_IN_WITH_MFA_SELECTION: [],
  CONTINUE_SIGN_IN_WITH_TOTP_SETUP: [],
  DONE: [],
  RESET_PASSWORD: [],
  COMPLETE_AUTO_SIGN_IN: []
};
